<ng-template #confirmCancelRga let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Confirm RGA Cancellation</h5>
		<button type="button" class="close" (click)="cancelModal(modal)">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<div class="modal-body px-3 pb-3">
		<div class="form-group">
			<label class="font-weight-bold d-block mb-3 text-primary h6">
				Choose a reason for cancellation
			</label>

			<div class="reason-grid">
				<button type="button" *ngFor="let reason of predefinedReasons" class="reason-tile" [class.selected]="cancelReason?.code === reason.code" (click)="selectReason(reason)">
					{{ reason.label }}
				</button>
			</div>
		</div>

		<div class="form-group mt-4" *ngIf="reasonRequiresNote">
			<label for="cancelNotes" class="font-weight-bold">Additional details</label>
			<textarea id="cancelNotes" class="form-control shadow-sm" placeholder="Please provide more info..." rows="3" [(ngModel)]="cancelNotes"></textarea>
		</div>

		<div *ngIf="showReasonError" class="alert alert-danger mt-3">
			{{ cancelReason && cancelReason.code === 'OTHER' && !cancelNotes.trim() ? 'Please provide additional details for this reason.' : 'Please select a cancellation reason to continue.' }}
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-danger" (click)="handleConfirmCancelRga(modal)">
			Confirm Cancellation
		</button>
	</div>
</ng-template>

<ng-template #rgaDetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">RGA</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<mat-tab-group #tabPanel mat-align-tabs="start" color="accent" class="no-overflow">
			<mat-tab label="RGA">
				<div class="mb-3" *ngIf="podetails">
					<h4 class="mt-3">RGA # {{ podetails.poheader.orderno }}</h4>
					<div class="table">
						<table class="table table-sm">
							<tr>
								<td>
									{{podetails.poheader.suppliercontact}}<br>
									{{podetails.poheader.suppdeladdress1}}<br>
									{{podetails.poheader.suppdeladdress2}}<br>
									{{podetails.poheader.suppdeladdress3}}, {{podetails.poheader.suppdeladdress4}} {{podetails.poheader.suppdeladdress5}}
								</td>
								<td>
									{{podetails.poheader.deladd1}}<br>
									<span *ngIf="podetails.poheader.deladd2 != ''">{{podetails.poheader.deladd2}}<br></span>
									{{podetails.poheader.deladd3}}, {{podetails.poheader.deladd4}} {{podetails.poheader.deladd5}}
								</td>
							</tr>
						</table>
						<div class="card">
							<div class="card-body" [innerHTML]="podetails.poheader.stat_comment"></div>
						</div>
						<table class="table table-sm ">
							<tr>
								<th>ITEM</th>
								<th>DESC</th>
								<th class="text-center">QTY</th>
								<th class="text-center">SENT</th>
								<th class="text-center">PEND</th>
								<th class="text-right">PRICE</th>
								<th class="text-right">TOTAL</th>
							</tr>
							<tr *ngFor="let item of podetails.polines">
								<td><a [routerLink]="'/inventory/view/'+item.itemcode" (click)="modal.dismiss('route change')">{{item.itemcode}}</a></td>
								<td>{{item.itemdescription}}</td>
								<td class="text-center">{{item.quantityord}}</td>
								<td class="text-center">{{item.quantityrecd}}</td>
								<td class="text-center">{{item.quantityord - item.quantityrecd}}</td>
								<td class="text-right">{{item.unitprice | currency}}</td>
								<td class="text-right">{{item.unitprice * item.quantityord | currency}}</td>
							</tr>
						</table>
					</div>
				</div>
			</mat-tab>
			<mat-tab label="Return Details">
				<ng-container *ngIf="podetails.receiving.length">
					<table class="table table-fixed table-sm">
						<tr>
							<th>GRN</th>
							<th>RGA#</th>
							<th>Item#</th>
							<th>Description</th>
							<th>Sent</th>
							<th>Invoiced</th>
							<th>Date</th>
						</tr>
						<tr *ngFor="let r of podetails.receiving">
							<td>{{ r.grnno }}</td>
							<td>{{ r.poorderno }}</td>
							<td>{{ r.itemcode }}</td>
							<td>{{ r.itemdescription }}</td>
							<td>{{ r.qtyrecd }}</td>
							<td>{{ r.quantityinv }}</td>
							<td>{{ r.update_date }}</td>
						</tr>
					</table>
				</ng-container>
				<ng-container *ngIf="!podetails.receiving.length">
					No Return Details
				</ng-container>
			</mat-tab>
			<mat-tab label="Return Movements">
				<ng-container *ngIf="podetails.movements.length">
					<table class="table table-fixed table-sm">
						<tr>
							<th>Item#</th>
							<th>Location</th>
							<th>User</th>
							<th>Quantity</th>
							<th>QOH</th>
							<th>Date</th>
						</tr>
						<tr *ngFor="let r of podetails.movements">
							<td>{{ r.stockid }}</td>
							<td>{{ r.loccode }}</td>
							<td>{{ r.userid }}</td>
							<td>{{ r.qty }}</td>
							<td>{{ r.newqoh }}</td>
							<td>{{ r.trandate }}</td>
						</tr>
					</table>
				</ng-container>
				<ng-container *ngIf="!podetails.movements.length">
					No Movements
				</ng-container>
			</mat-tab>
		</mat-tab-group>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div class="row open-rga-toolbar m-0 mt-2 align-items-start flex-wrap">
	<div class="col-12 col-sm-auto mb-2 mb-sm-0 text-left">
		<button mat-raised-button type="submit" color="accent" (click)="exportExcel()" *ngIf="rgas">
			<i class="material-icons">text_snippet</i> XLS
		</button>
	</div>
	<div class="col-12 col-sm-6 col-md-4 mb-2 mb-md-0">
		<mat-form-field appearance="outline" class="w-100" *ngIf="statuses">
			<mat-label>Status</mat-label>
			<mat-select [formControl]="status" >
				<mat-option [value]="''">All</mat-option>
				<mat-option *ngFor="let v of statuses" [value]="v.status_id">
					{{v.name}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="col-12 col-md-8 mb-2 mb-md-0" *ngIf="!vendor || !vendor.supplierid">
		<mat-form-field appearance="outline" class="w-100 text-right">
			<mat-label>Search</mat-label>
			<input tabindex="1" matInput value="" (input)="onInput()" [formControl]="vendorSearch" class="text-right" autofocus (keydown.enter)="$event.preventDefault();onInput()">
			<span matSuffix>
				<button tabindex="-1" mat-icon-button color="white" (click)="searchRgas()">
					<mat-icon>search</mat-icon>
				</button>
				<button tabindex="-1" mat-icon-button color="primary" (click)="loadData()" class="ml-1">
					<mat-icon>refresh</mat-icon>
				</button>
			</span>
			<mat-progress-bar mode="indeterminate" color="accent" *ngIf="searching"></mat-progress-bar>
		</mat-form-field>
	</div>
	<div class="col-12 col-md-8 mb-2 mb-md-0" *ngIf="vendor && vendor.supplierid">
		<div class="d-flex justify-content-end align-items-center flex-wrap">
			<div class="vendor-context-info mr-2 mb-1">
				<strong>Vendor:</strong> {{ vendor.suppname || vendor.supplierid }}
			</div>
			<button mat-icon-button color="primary" (click)="loadData()">
				<mat-icon>refresh</mat-icon>
			</button>
		</div>
	</div>
</div>
<div class="row m-0">
	<div class="col-12 table table-responsive text-center py-3" *ngIf="!allrgas">
		<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
			</circle>
		</svg>
	</div>
</div>
<div class="table-container po-rga-mat-table-scroll">
	<table mat-table [dataSource]="rgas" matSort (matSortChange)="announceSortChange($event)" class="open-rga-mat-table">
		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
			<td mat-cell *matCellDef="let tran">
				<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
					<mat-icon>more_vert</mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="viewRga(tran.orderno, rgaDetails)">
						<mat-icon>visibility</mat-icon>
						<span>View</span>
					</button>
					<a href="{{config.apiServer.baseUrl}}{{baselink}}{{tran.orderno}}" mat-menu-item>
						<mat-icon>print</mat-icon>
						<span>PDF</span>
					</a>
					<a href="{{config.apiServer.baseUrl}}{{reclink}}{{tran.orderno}}" mat-menu-item>
						<mat-icon>print</mat-icon>
						<span>Return Doc</span>
					</a>
					<mat-divider></mat-divider>
					<a [routerLink]="'/purchasing/rga-return/'+tran.orderno" mat-menu-item>
						<mat-icon>call_made</mat-icon>
						<span>Return</span>
					</a>
					<mat-divider></mat-divider>
					<button mat-menu-item (click)="loadRga(tran.orderno)">
						<mat-icon>edit</mat-icon>
						<span>Edit RGA</span>
					</button>
					<mat-divider></mat-divider>
					<button mat-menu-item (click)="cancelRga(tran.orderno)">
						<mat-icon>remove</mat-icon>
						<span>Cancel</span>
					</button>
					<button mat-menu-item [routerLink]="'/receivables/dispatch/'+tran.orderno">
						<mat-icon>description</mat-icon>
						<span>Credit Account</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<ng-container matColumnDef="status_id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
			<td mat-cell *matCellDef="let tran">
			<ng-container *ngIf="!tran.editing">
				<span class="order-status-pill order-status-pill--row status-{{tran.status}}">
					<span class="order-status-pill__start"></span>
					<span class="order-status-pill__text">{{ tran.statusname }}</span>
					<span class="order-status-pill__end">
						<i class="fa fa-edit order-status-pill__edit" (click)="toggleStatusChange(tran); $event.stopPropagation()"></i>
					</span>
				</span>
			</ng-container>
				<mat-form-field appearance="outline" *ngIf="tran.editing">
					<mat-label>Status</mat-label>
					<span matPrefix *ngIf="tran.editing">
						<mat-icon (click)="toggleStatusChange(tran)" class="smaller">clear</mat-icon>
					</span>
					<mat-select [(value)]="tran.status_id" (selectionChange)="updateStatus($event, tran)">
						<mat-option *ngFor="let status of statuses" [(value)]="status.status_id">{{ status.name }}</mat-option>
					</mat-select>

				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="orderno">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>RGA#</th>
			<td mat-cell *matCellDef="let tran">{{ tran.orderno }}</td>
		</ng-container>
		<ng-container matColumnDef="orddate">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
			<td mat-cell *matCellDef="let tran">{{ tran.orddate }}</td>
		</ng-container>
		<ng-container matColumnDef="suppname">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor</th>
			<td mat-cell *matCellDef="let tran">
				{{ tran.suppname }}
			</td>
		</ng-container>
		<ng-container matColumnDef="requisitionno">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Req#</th>
			<td mat-cell *matCellDef="let tran">{{ tran.requisitionno }}</td>
		</ng-container>

		<ng-container matColumnDef="creditvalue">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Net $</th>
			<td mat-cell *matCellDef="let tran">{{ tran.ordervalue | currency }}</td>
		</ng-container>
		<ng-container matColumnDef="creditpendingvalue">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Pending $</th>
			<td mat-cell *matCellDef="let tran">{{ tran.orderpendingvalue | currency }}</td>
		</ng-container>
		<ng-container matColumnDef="credititems" >
			<th mat-header-cell *matHeaderCellDef mat-sort-header >CRED/SENT/PEND</th>
			<td mat-cell *matCellDef="let tran" >{{ tran.ordered }}/{{ tran.rec }}/<b>{{ tran.pendingitems }}</b></td>
		</ng-container>
		<ng-container matColumnDef="deliverydate">
			<th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="text-right">Date Wanted</th>
			<td mat-cell *matCellDef="let tran" class="text-right">{{ tran.deliverydate }}</td>
		</ng-container>
		<ng-container matColumnDef="initiator">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right" arrowPosition="before"> Initiator</th>

			<td mat-cell *matCellDef="let tran" class="text-right">
				{{ tran.initiator }}
			</td>
		</ng-container>
		<!-- PGS 360 RMA column — only rendered when tpl3plPgsEnabled -->
		<ng-container matColumnDef="pgs360_rma">
			<th mat-header-cell *matHeaderCellDef>PGS 360</th>
			<td mat-cell *matCellDef="let tran">
				<ng-container *ngIf="tran.tpl3pl_rma_response; else pgsSend">
					<!-- Already sent — show badge + re-send icon -->
					<span class="badge badge-success" style="font-size:0.72rem;"
					      [title]="(tran.tpl3pl_rma_response | json)">Sent to PGS</span>
					<button mat-icon-button style="vertical-align:middle;"
					        title="Force re-send to PGS 360"
					        [disabled]="pgsSendingOrderNo === tran.orderno"
					        (click)="sendRgaToPgs(tran.orderno, true)">
						<mat-icon style="font-size:16px;">refresh</mat-icon>
					</button>
				</ng-container>
				<ng-template #pgsSend>
					<button mat-stroked-button color="primary" style="font-size:0.75rem;line-height:28px;padding:0 8px;"
					        [disabled]="pgsSendingOrderNo === tran.orderno"
					        (click)="sendRgaToPgs(tran.orderno)">
						<mat-icon style="font-size:16px;vertical-align:middle;">assignment_return</mat-icon>
						{{ pgsSendingOrderNo === tran.orderno ? 'Sending…' : 'Send RMA' }}
					</button>
				</ng-template>
				<!-- Inline result feedback after send attempt -->
				<div *ngIf="pgsResultByOrder[tran.orderno] as res" style="font-size:0.72rem;margin-top:2px;"
				     [style.color]="res.success ? 'green' : 'crimson'">
					{{ res.message }}<span *ngIf="res.cached"> (cached)</span>
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="headercolumns;sticky: true;"></tr>
		<tr mat-row *matRowDef="let row; columns: headercolumns"></tr>
	</table>

	<mat-paginator [pageSizeOptions]="[50, 100, 500]" showFirstLastButtons aria-label="select page">
	</mat-paginator>
</div>
